import appApi from '../../../../../../api/app-api';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import { toast } from 'react-toastify';
import { HttpStatusCode } from 'axios';

export const activateProgramOperation = async (
  branchId: number,
  abstractProgramId: number,
  startYear: number,
  setLoading: (loading: boolean) => any,
  navigate: NavigateFunction,
) => {
  try {
    if (!branchId) {
      toast.warn('יש לבחור את הסניף המבוקש');
    }
    setLoading(true);
    const res = await appApi.activateProgram(
      branchId,
      abstractProgramId,
      startYear,
    );
    setLoading(false);
    if (res.status !== HttpStatusCode.Ok) {
      throw new Error('Create new program is failed');
    }
    /*globalProgramStore.addProgram(res.data.body);
    globalProgramStore.currentId = res.data.body.metadata.id;*/
    //navigate(`/programs/${res.data.body.metadata.id}`);
    navigate(`/campuses/${branchId}/programs/${res.data.body.metadata.id}`);
  } catch (e) {
    setLoading(false);
    console.error(
      `activateProgramOperation is failed with abstractProgramId: ${abstractProgramId} and the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
